module.exports = __webpack_public_path__ + "static/media/034-electric toothbrush.9c0fe22f.svg";